import { useTranslation } from 'react-i18next'

import { IPlanMenuControlOrdersRequest } from 'core/api/dto/PlanMenuControlDto'
import { useSearchParams } from 'react-router-dom'

import AppBtn, { AppBtnColor, AppBtnSize } from 'components/btn/AppBtn'
import { useGetPlanMenuCloseDimensionQuery } from 'core/api/PlanMenuCloseDimensionApi'

export interface IMilletBlockProps {
  pageParams: IPlanMenuControlOrdersRequest | null
  onClick: () => void
}

export const MilletBlock = ({ pageParams, onClick }: IMilletBlockProps) => {
  const { t } = useTranslation()

  const [searchParams] = useSearchParams()
  const currentDimension = searchParams.get('dimension')
  const { data } = useGetPlanMenuCloseDimensionQuery({
    id: Number(currentDimension),
  })
  return (
    <>
      {data ? (
        <div className={`millet-block `} onClick={onClick}>
          <AppBtn sized={AppBtnSize.fullWidth} color={AppBtnColor.lightViolet}>
            <div>
              <i className="an-ico an-ico-bowl" />
              <span>{t('Выбрать тару')}</span>
            </div>
          </AppBtn>
          <div className="text-info">
            <i className="an-ico an-ico-info-circle " />
            <span>
              {t(
                'Выберете необходимую тару из списка, применив её к замеру блюда',
              )}
            </span>
          </div>
          <div>
            <div className="">
              <img
                src={
                  data.milletType?.milletPhotoOnS3 || data.milletType?.milletPhoto || '../../assets/images/fake-millet.png'
                }
                alt=""
              />
            </div>
            <div className={'label-text'}>{t('Название тары')}</div>
            <div className={'title'}>{data?.milletType?.milletName}</div>
            <div className={'text'}>{`${data?.milletWeight} кг`} </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}
